"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var styles = {
  root: {
    zIndex: 5,
    borderRadius: '3px',
    boxShadow: function boxShadow(_ref) {
      var uncontained = _ref.uncontained;
      return uncontained ? '' : '0px 1px 4px rgba(0, 0, 0, 0.1)';
    },
    margin: function margin(_ref2) {
      var placement = _ref2.placement,
          uncontained = _ref2.uncontained,
          hideArrow = _ref2.hideArrow;
      var px = uncontained || hideArrow ? '5px' : '10px';
      if (placement.includes('top') || placement.includes('bottom')) return "".concat(px, " 0");
      return "0 ".concat(px);
    },
    border: function border(_ref3) {
      var uncontained = _ref3.uncontained,
          borderColor = _ref3.borderColor;
      return uncontained ? '' : "1px solid ".concat(borderColor);
    },
    backgroundColor: function backgroundColor(_ref4) {
      var uncontained = _ref4.uncontained,
          _backgroundColor = _ref4.backgroundColor;
      return uncontained ? '' : _backgroundColor;
    }
  },
  arrowBase: {
    position: 'absolute',
    borderWidth: '7px',
    borderColor: 'transparent',
    borderStyle: 'solid'
  },
  arrowAfter: {
    extend: 'arrowBase',
    content: '" "'
  },
  topArrow: {
    extend: 'arrowBase',
    display: function display(_ref5) {
      var uncontained = _ref5.uncontained;
      return uncontained ? 'none' : '';
    },
    top: '100%',
    borderBottomWidth: 0,
    borderTopColor: function borderTopColor(_ref6) {
      var borderColor = _ref6.borderColor;
      return borderColor;
    },
    '&::after': {
      extend: 'arrowAfter',
      top: '-8px',
      left: '-7px',
      borderBottomWidth: 0,
      borderTopColor: function borderTopColor(_ref7) {
        var backgroundColor = _ref7.backgroundColor;
        return backgroundColor;
      }
    }
  },
  rightArrow: {
    extend: 'arrowBase',
    display: function display(_ref8) {
      var uncontained = _ref8.uncontained;
      return uncontained ? 'none' : '';
    },
    right: '100%',
    borderLeftWidth: 0,
    borderRightColor: function borderRightColor(_ref9) {
      var borderColor = _ref9.borderColor;
      return borderColor;
    },
    transform: function transform(_ref10) {
      var placement = _ref10.placement;
      if (placement.includes('start')) return 'translateY(5px)';
      if (placement.includes('end')) return 'translateY(-5px)';
      return '';
    },
    '&::after': {
      extend: 'arrowAfter',
      top: '-7px',
      left: '1px',
      borderLeftWidth: 0,
      borderRightColor: function borderRightColor(_ref11) {
        var backgroundColor = _ref11.backgroundColor;
        return backgroundColor;
      }
    }
  },
  bottomArrow: {
    extend: 'arrowBase',
    display: function display(_ref12) {
      var uncontained = _ref12.uncontained;
      return uncontained ? 'none' : '';
    },
    bottom: '100%',
    borderTopWidth: 0,
    borderBottomColor: function borderBottomColor(_ref13) {
      var borderColor = _ref13.borderColor;
      return borderColor;
    },
    '&::after': {
      extend: 'arrowAfter',
      top: '1px',
      left: '-7px',
      borderTopWidth: 0,
      borderBottomColor: function borderBottomColor(_ref14) {
        var backgroundColor = _ref14.backgroundColor;
        return backgroundColor;
      }
    }
  },
  leftArrow: {
    extend: 'arrowBase',
    display: function display(_ref15) {
      var uncontained = _ref15.uncontained;
      return uncontained ? 'none' : '';
    },
    left: '100%',
    borderRightWidth: 0,
    borderLeftColor: function borderLeftColor(_ref16) {
      var borderColor = _ref16.borderColor;
      return borderColor;
    },
    transform: function transform(_ref17) {
      var placement = _ref17.placement;
      if (placement.includes('start')) return 'translateY(5px)';
      if (placement.includes('end')) return 'translateY(-5px)';
      return '';
    },
    '&::after': {
      extend: 'arrowAfter',
      top: '-7px',
      left: '-8px',
      borderRightWidth: 0,
      borderLeftColor: function borderLeftColor(_ref18) {
        var backgroundColor = _ref18.backgroundColor;
        return backgroundColor;
      }
    }
  }
};
var _default = styles;
exports["default"] = _default;